import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllUsers, toggleUserStatus } from '../../services/adminService';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';

const ManageUsers = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const { token } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate('/admin-login');
            return;
        }
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const data = await getAllUsers();
            setUsers(data);
        } catch (error) {
            toast.error('Error fetching users');
        } finally {
            setLoading(false);
        }
    };

    const handleToggleStatus = async (id) => {
        try {
            await toggleUserStatus(id);
            toast.success('User status updated!');
            fetchUsers();
        } catch (error) {
            toast.error('Error updating user status');
        }
    };

    const filteredUsers = users.filter(user =>
        user.firstName?.toLowerCase().includes(
            search.toLowerCase()) ||
        user.email?.toLowerCase().includes(
            search.toLowerCase()) ||
        user.phoneNumber?.includes(search)
    );

    if (loading) return (
        <div className="text-center py-5">
            <div className="spinner-border"
                style={{ color: '#8B4513' }}>
            </div>
        </div>
    );

    return (
        <div className="container py-4">
            <h2 className="fw-bold mb-4">👤 Manage Users</h2>

            {/* Search */}
            <div className="mb-4">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search by name, email or phone..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            <p className="text-muted mb-3">
                Total: <strong>{filteredUsers.length}</strong> users
            </p>

            {filteredUsers.length === 0 ? (
                <p className="text-muted text-center py-4">
                    No users found
                </p>
            ) : (
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead style={{ backgroundColor: '#FFF8F0' }}>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Role</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredUsers.map(user => (
                                <tr key={user.id}>
                                    <td>#{user.id}</td>
                                    <td>
                                        {user.firstName} {user.lastName}
                                    </td>
                                    <td>{user.email}</td>
                                    <td>{user.phoneNumber}</td>
                                    <td>
                                        <span className="badge bg-primary">
                                            {user.role}
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`badge ${user.isActive
                                            ? 'bg-success'
                                            : 'bg-danger'}`}>
                                            {user.isActive
                                                ? 'Active'
                                                : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>
                                        <button
                                            className={`btn btn-sm ${user.isActive
                                                ? 'btn-danger'
                                                : 'btn-success'}`}
                                            onClick={() =>
                                                handleToggleStatus(user.id)}>
                                            {user.isActive
                                                ? 'Deactivate'
                                                : 'Activate'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default ManageUsers;